import React from 'react';
import { PageHeader } from '@/components/ui/page-header';
import { PageContainer } from '@/components/ui/page-container';
import { pageNameFor } from '../lib/pageTitles';

/**
 * A page the route guards keep someone out of (a role, plan or permission
 * they don't have) still opens with its header, named as the nav names it,
 * so it reads as that page, closed, rather than a card from nowhere.
 */
export function BlockedPage({ pathname, children }: { pathname: string; children: React.ReactNode }) {
  return (
    <PageContainer width="narrow">
      <PageHeader title={pageNameFor(pathname) ?? 'Cadence'} />
      {children}
    </PageContainer>
  );
}
